(function() {
  'use strict';

  angular.module('component.bulkActions')
    .component('bulkActionsComponent', {
      templateUrl: 'app/components/bulk-actions/bulk-actions.html',
      controller: 'BulkActionsController',
      controllerAs: 'bulkActionsCtrl'
    });
})();
